var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 51,
    viewBox: "0 0 113 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_3495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.57 25.33L42.25 0V50.66L70.57 25.33Z",
    fill: "#66C67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.82 25.33L84.5 0V50.66L112.82 25.33Z",
    fill: "#66C67F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.33 25.33L0 0V50.66L28.33 25.33Z",
    fill: "#A0DEB6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_3495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.82,
    height: 50.66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow_1.b05f0e0300387715e6beae5ef7614b2d.svg";
export { ForwardRef as ReactComponent };